import React from 'react';

import { Button, Link, Stack, Typography } from '@mui/material';

import { EmptyIllustration } from '../empty-states/EmptyIllustration';

type Props = {
  emptyMessageTutorial?: JsxNode;
  emptyFilters: boolean;
  resetFilters: () => void;
};
export default function EmptyResultsMessage({ emptyMessageTutorial, emptyFilters, resetFilters }: Props) {
  if (emptyMessageTutorial && emptyFilters) {
    return emptyMessageTutorial;
  }

  if (!emptyFilters) {
    return (
      <EmptyIllustration
        caption={
          <Stack spacing={2} alignItems="center">
            <Typography color="text.secondary">No messages found</Typography>
            <Button variant="contained" onClick={resetFilters}>
              Remove filters
            </Button>
          </Stack>
        }
      />
    );
  }

  return (
    <EmptyIllustration
      caption={
        <Typography color="text.secondary">
          Message events will show up here &mdash;{' '}
          <Link
            href="https://www.usewaypoint.com/docs/activity-and-metrics"
            color="inherit"
            underline="always"
            target="_blank"
          >
            learn more
          </Link>
          .
        </Typography>
      }
    />
  );
}
